export const FILTER_TYPE_LABELS = {
    Text: 'Text',
    Video: 'Video',
    Audio: 'Audio',
    Poll: 'Poll',
    Image: 'Image',
};
